function updateAmazonStyleDots() {
  const scroller = document.querySelector('.product-gallery--navigation .gallery-navigation--scroller');
  if (!scroller) return;

  const dots = Array.from(
    scroller.querySelectorAll('.product-gallery--media-thumbnail')
  );

  const total = dots.length;
  if (!total) return;

  const activeIndex = dots.findIndex(
    dot => dot.getAttribute('data-gallery-selected') === 'true'
  );

  if (activeIndex === -1) return;

  /* ----------------------
     1. AMAZON STYLE DOTS
  ----------------------- */

  const windowSize = 5;
  const centerIndex = 2;

  let start = activeIndex - centerIndex;
  let end = start + windowSize - 1;

  if (total <= windowSize) {
    dots.forEach(d => d.classList.add('is-visible'));
  } else {
    if (start < 0) {
      start = 0;
      end = windowSize - 1;
    }

    if (end >= total) {
      end = total - 1;
      start = end - windowSize + 1;
    }

    dots.forEach((dot, index) => {
      dot.classList.remove('is-visible', 'is-edge');

      if (index >= start && index <= end) {
        dot.classList.add('is-visible');

        if (index === start || index === end) {
          dot.classList.add('is-edge');
        }
      }
    });
  }

  /* ----------------------
     2. CENTER ACTIVE DOT
  ----------------------- */

  const activeDot = dots[activeIndex];

  const dotCenter =
    activeDot.offsetLeft + activeDot.offsetWidth / 2;

  const containerCenter =
    scroller.clientWidth / 2;

  const targetScrollLeft =
    dotCenter - containerCenter;

  scroller.scrollTo({
    left: targetScrollLeft,
    behavior: 'smooth'
  });
}


const galleryRoot = document.querySelector('.product-gallery--navigation .gallery-navigation--scroller');

if (galleryRoot && window.innerWidth < 767) {
  const observer = new MutationObserver(updateAmazonStyleDots);

  observer.observe(galleryRoot, {
    subtree: true,
    attributes: true,
    attributeFilter: ['data-gallery-selected']
  });

  updateAmazonStyleDots();
}

document.addEventListener('DOMContentLoaded', () => {
  const trigger = document.querySelector('.qty-dropdown-trigger');
  const list = document.querySelector('.qty-dropdown-list');
  const selectedText = document.querySelector('.qty-selected');
  const qtyInput = document.querySelector('.product-form--regular .quantity-selector__input');

  if (!trigger || !list || !qtyInput) return;

  trigger.addEventListener('click', () => {
    list.style.display = list.style.display === 'block' ? 'none' : 'block';
  });

  list.querySelectorAll('li').forEach(li => {
    li.addEventListener('click', () => {
      const value = li.dataset.value;

      selectedText.textContent = value;
      qtyInput.value = value;

      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

      list.style.display = 'none';
    });
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.qty-dropdown-wrapper')) {
      list.style.display = 'none';
    }
  });
});
